import React from "react";
import moment from "moment";
import { activityTone } from "./crewActivityRules";
import { ActivityCell } from "./CrewActivityGrid";
import ActivityActions from "./ActivityActions";

const time = (value) => (value ? moment(value).format("DD/MM HH:mm") : "—");
const TONE_TEXT = { hotel: "Hotel can be changed", nonfly: "Non fly", fly: "Fly" };

/** One crew activity as a card (phones / small tablets): crew, duty, route, times, transporter and touch actions. */
export default function CrewActivityCard({ row, actions }) {
  const tone = activityTone(row);
  return (
    <article className={`dsp-card is-cra-${tone}`} aria-label={`Activity ${row.employeeNumber} ${row.transactionId || ""}`.trim()}>
      <header className="dsp-card__head">
        <span className="dsp-card__id">{row.fullName || row.employeeNumber}</span>
        <span className={`dsp-chip is-cra-${tone}`}>{TONE_TEXT[tone]}</span>
      </header>
      <div className="dsp-card__crew">
        <span>
          {row.employeeNumber}
          {row.airlineCrewType ? ` · ${row.airlineCrewType}` : ""}
          {row.crewBaseStation ? ` · Base ${row.crewBaseStation}` : ""}
        </span>
      </div>
      <ol className="dsp-card__route">
        <li>
          <i className="fas fa-circle" aria-hidden="true" /> {row.pickupLocation || "—"}
        </li>
        <li>
          <i className="fas fa-map-marker-alt" aria-hidden="true" /> {row.dropOffLocation || "—"}
        </li>
      </ol>
      <dl className="dsp-card__facts">
        <div>
          <dt>Activity</dt>
          <dd>
            <ActivityCell row={row} />
          </dd>
        </div>
        <div>
          <dt>Pickup</dt>
          <dd>{time(row.pickupTime)}</dd>
        </div>
        <div>
          <dt>Reporting</dt>
          <dd>{time(row.dutyReportingTime)}</dd>
        </div>
        <div>
          <dt>Airport</dt>
          <dd>{row.airportCode || "—"}</dd>
        </div>
        <div className="dsp-card__wide">
          <dt>Transporter</dt>
          <dd>{row.transportationCompany || "—"}</dd>
        </div>
      </dl>
      <footer className="dsp-card__foot">
        <ActivityActions row={row} {...actions} large />
      </footer>
    </article>
  );
}
